import React, {Component} from 'react';
import Styles from './style.css';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import HeaderMobileMenuDashboard from "../header-mobile-menu-dashboard/component";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class HeaderDashboardOne extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: "",
            user: null,
            reseller: false,
            lang: {}
        };
    };

    componentWillMount() {
        this._updateUser();
        this._updateView();
    }

    _updateUser() {
        let user = userRegister.get();
        try {
            this.setState({
                user: user,
                reseller: user.reseller,
                inhouse: user.inhouse
            });
        } catch (e) {
        }
    }

    _updateView() {
        if (this.props.view) {
            this.setState({
                view: this.props.view
            });
        } else {
            this.setState({
                view: "register"
            });
        }
    }

    _signout() {
        userRegister.remove();
        tokenRegister.remove();
        demoRegister.remove();
        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/login");
    }

    _openMenu() {
        this.child._openMenu();
    }

    _home() {
        try {
            if(this.props.props.location.pathname.indexOf("running") === -1){
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/user/campaigns/running");
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name'));
            }
        } catch (e) {}
    }

    _register() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/register");

        } catch (e) {}
    }

    _profile() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/user/campaigns/running");
        } catch (e) {}
    }

    _login() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/login");
        } catch (e) {}
    }

    _renderText(item) {
        return langRegister.get("signup-header-one", item, "sv");
    }

    render() {
        return (
            <div className={Styles.header}>
                <div className={Styles.logoContainer}>
                    <img onClick={() => this._home()} className={Styles.logoContainerIcon}
                         src={salesChannelRegister.get('logo_dashboard')}/>
                    <img onClick={() => this._home()} className={Styles.logoContainerIconMobile}
                         src={salesChannelRegister.get('logo_mobile')}/>
                </div>
                <div className={Styles.menuContainer}></div>
                <div className={Styles.buttonContainer}>
                    {
                        !this.state.user && this.state.view === "login" &&
                        <div onClick={() => this._register()} className={Styles.buttonContainerSignIn}>
                            {this._renderText("item_1")}
                        </div>
                    }
                    {
                        !this.state.user && this.state.view === "register" &&
                        <div onClick={() => this._login()} className={Styles.buttonContainerSignIn}>
                            {this._renderText("item_3")}
                        </div>
                    }
                    {
                        this.state.user &&
                        <div onClick={() => this._signout()} className={Styles.buttonContainerSignIn}>
                            {this._renderText("item_2")}
                        </div>
                    }
                    {
                        this.state.reseller && !this.state.inhouse &&
                        <div className={Styles.menuVipStatus}>
                            VIP
                        </div>
                    }
                    {
                        this.state.inhouse &&
                        <div className={Styles.menuInhouseStatus}>
                            INHOUSE
                        </div>
                    }
                    <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                         src={require("../../assets/images/menu_icon.svg")}/>
                </div>
                <HeaderMobileMenuDashboard props={this.props.props} ref={instance => {
                    this.child = instance
                }} layout={true}/>
            </div>
        );
    }
}

export default HeaderDashboardOne;


// WEBPACK FOOTER //
// ./src/components/header-dashboard-one/component.js